import React from "react";
import { useDroppable } from "@dnd-kit/core";
import { Box } from "@mui/material";

export interface TimeSlot {
  id: string;
  date: Date;
  hour: number;
  minute: number;
}

interface TimeDropZoneProps {
  slot: TimeSlot;
  height: number;
  children?: React.ReactNode;
  showHoverIndicator?: boolean;
}

const TimeDropZone: React.FC<TimeDropZoneProps> = ({
  slot,
  height,
  children,
  showHoverIndicator = true,
}) => {
  const { isOver, setNodeRef } = useDroppable({
    id: slot.id,
    data: slot,
  });

  return (
    <Box
      ref={setNodeRef}
      sx={{
        height: `${height}px`,
        position: "relative",
        transition: "background-color 0.15s ease",
        ...(isOver && showHoverIndicator
          ? {
              bgcolor: "rgba(33, 150, 243, 0.08)",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "2px",
                bgcolor: "primary.main",
                zIndex: 10,
              },
            }
          : {}),
      }}
    >
      {children}
    </Box>
  );
};

export default TimeDropZone;
